class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M10.75 3.5v2h3c.3 0 .5.2.5.5v.1L13.792 9h-1.03l.386-2.5H2.35L3.2 12H9v1H3.2c-.5 0-.95-.349-1-.849L1.25 6.1V6c-.001-.3.199-.5.499-.5h3v-2c0-.849.651-1.5 1.5-1.5H9.25c.85 0 1.5.651 1.5 1.5Zm-1.002 2H5.749v-2c0-.3.2-.5.5-.5h2.999c.3 0 .5.2.5.5v2Z" clip-rule="evenodd"></path><path d="M15 12.016h-2v-2h-1v2h-2v1h2v2h1v-2h2v-1Z"></path></svg>';
  }
}
const e = "pi-reseller";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
